import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { tours } from '../utils/mockData';
import { TourCard } from './TourCard';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const ExperiencesSection = () => {
  const { t } = useLanguage();

  // Show first 3 tours on homepage
  const featuredTours = tours.slice(0, 3);

  return (
    <section id="experiences" className="py-24 bg-[#F5F3F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 fade-in-up">
          <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] mb-4">
            {t('experiencesTitle')}
          </h2>
          <p className="text-lg text-[#8B7D6B] max-w-2xl mx-auto">
            {t('experiencesSubtitle')}
          </p>
        </div>

        {/* Tours Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredTours.map((tour, index) => (
            <div
              key={tour.id}
              className="fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <TourCard tour={tour} />
            </div>
          ))}
        </div>

        {/* View All Tours Button */}
        <div className="text-center fade-in-up">
          <Link to="/tours">
            <Button className="bg-[#C4B5A0] hover:bg-[#6B4E37] text-white px-8 py-6 text-lg">
              View All Tours
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};